import { GET_GUIDEWAY_PIECE_SIZE_CSTIC_NAME } from "~/Configurators/Linear/constants";
import { getDirtyParamName } from "~/Configurators/Linear/namingUtils";
import { KmatType } from "~/Configurators/Linear/getKmatType";

export const getGuidewayPieceDirtyParamName = (kmatIndex: number, pieceIndex: number) => {
  return getDirtyParamName({
    key: GET_GUIDEWAY_PIECE_SIZE_CSTIC_NAME(pieceIndex),
    index: kmatIndex,
    type: KmatType.GUIDEWAY,
  });
};
